(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ob-navigation"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ob-navigation')){
  customElements.define('ob-navigation',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const opts={signal:this.controller.signal};
      const groups=[...this.querySelectorAll('.ob-nav__item')];
      const close=(except)=>groups.forEach(d=>{if(d!==except)d.open=false});
      groups.forEach(d=>{
        d.addEventListener('toggle',()=>{d.querySelector('summary').setAttribute('aria-expanded',String(d.open));if(d.open)close(d)},opts);
        d.querySelector('summary').setAttribute('aria-expanded',String(d.open));
      });
      document.addEventListener('click',e=>{if(!this.contains(e.target))close()},opts);
      this.addEventListener('keydown',e=>{if(e.key==='Escape'){const d=e.target.closest('.ob-nav__item');if(d&&d.open){e.preventDefault();d.open=false;d.querySelector('summary').focus()}}},opts);
      this.addEventListener('focusout',e=>{if(e.relatedTarget&&!this.contains(e.relatedTarget))close()},opts);
      window.addEventListener('resize',()=>{if(window.innerWidth<1024)close()},opts);
      const forms=this.querySelectorAll('form');
      forms.forEach(form=>{if(form.querySelector('[role=alert],[role=status]')){const d=form.closest('details');if(d)d.open=true}});
    }
    disconnectedCallback(){this.controller?.abort()}
  });
}
if(!customElements.get('ob-mobile-navigation')){
  customElements.define('ob-mobile-navigation',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      this.querySelectorAll('details').forEach(d=>d.addEventListener('toggle',()=>{
        if(d.open){
          const parent=d.parentElement;
          const siblings=parent.tagName==='LI'?[...parent.parentElement.children].map(li=>li.querySelector(':scope > details')):[...parent.children].filter(el=>el.tagName==='DETAILS');
          siblings.forEach(other=>{if(other&&other!==d)other.open=false});
        }
      },{signal:this.controller.signal}));
    }
    disconnectedCallback(){this.controller?.abort()}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ob-offer-carousel"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ob-offer-carousel')){
customElements.define('ob-offer-carousel',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.slides=[...this.querySelectorAll('[data-slide]')];this.index=0;this.abort=new AbortController();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.dataset.autoplay!=='true'||this.motion.matches;this.hovered=false;this.focused=false;
const options={signal:this.abort.signal};this.toggle=this.querySelector('[data-pause]');
this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(-1),options);this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(1),options);
this.toggle?.addEventListener('click',()=>{this.paused=!this.paused;this.restart()},options);
this.addEventListener('mouseenter',()=>{this.hovered=true;this.restart()},options);this.addEventListener('mouseleave',()=>{this.hovered=false;this.restart()},options);
this.addEventListener('focusin',()=>{this.focused=true;this.restart()},options);this.addEventListener('focusout',()=>{queueMicrotask(()=>{this.focused=this.contains(document.activeElement);this.restart()})},options);
document.addEventListener('visibilitychange',()=>this.restart(),options);this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.restart()},options);
this.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.move(e.key==='ArrowRight'?1:-1)}},options);
this.addEventListener('touchstart',e=>{this.startX=e.changedTouches[0].clientX;this.startY=e.changedTouches[0].clientY},{...options,passive:true});
this.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-this.startX;const dy=e.changedTouches[0].clientY-this.startY;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)){this.suppressClick=true;this.move(dx<0?1:-1);setTimeout(()=>this.suppressClick=false,400)}},{...options,passive:true});
this.addEventListener('click',e=>{if(this.suppressClick){e.preventDefault();this.suppressClick=false}},options);
document.addEventListener('shopify:block:select',e=>{const n=this.slides.findIndex(s=>s.dataset.shopifyEditorBlock&&JSON.parse(s.dataset.shopifyEditorBlock).id===e.detail.blockId);if(n>=0){this.paused=true;this.show(n);this.restart()}},options);this.restart();
}
show(n){this.index=(n+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);const status=this.querySelector('[data-status]');if(status)status.textContent=(this.index+1)+' / '+this.slides.length}
move(n){this.show(this.index+n);this.restart()}
restart(){clearInterval(this.timer);if(this.toggle){this.toggle.textContent=this.paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel;this.toggle.setAttribute('aria-pressed',String(this.paused))}if(!this.paused&&!this.hovered&&!this.focused&&!document.hidden&&this.slides.length>1)this.timer=setInterval(()=>this.show(this.index+1),Number(this.dataset.interval)||5000)}
disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.ready=false}
});
}
  } catch(e) { console.error(e); }
})();

})();
